module.exports = __webpack_public_path__ + "img/no_flag_found.e596028c.svg";